var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 6.90909,
    fill: "#D4DFF3",
    fillOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12.5C11.8954 12.5 11 13.3954 11 14.5V23.5C11 24.6046 11.8954 25.5 13 25.5H24.7143C25.8189 25.5 26.7143 24.6046 26.7143 23.5V22.6667H22.5714C20.565 22.6667 19 20.9905 19 19C19 17.0095 20.565 15.3333 22.5714 15.3333H26.7143V14.5C26.7143 13.3954 25.8189 12.5 24.7143 12.5H13ZM28.7143 15.3333V14.5C28.7143 12.2909 26.9234 10.5 24.7143 10.5H13C10.7909 10.5 9 12.2909 9 14.5V23.5C9 25.7091 10.7909 27.5 13 27.5H24.7143C26.9234 27.5 28.7143 25.7091 28.7143 23.5V22.6667H28.9109C29.5463 22.6667 30 22.143 30 21.5743V16.4257C30 15.857 29.5463 15.3333 28.9109 15.3333H28.7143ZM28 17.3333H22.5714C21.7375 17.3333 21 18.0449 21 19C21 19.9551 21.7375 20.6667 22.5714 20.6667H28V17.3333Z",
    fill: "#ADBFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.84c1767ad3a44d9d03411552a0beef65.svg";
export { ForwardRef as ReactComponent };